
import React from 'react';
import { Skeleton } from './skeleton';
import { Card, CardContent, CardHeader } from './card';

interface SkeletonCardProps {
  showHeader?: boolean;
  showFooter?: boolean;
  headerHeight?: string;
  contentLines?: number;
  className?: string;
}

export const SkeletonCard: React.FC<SkeletonCardProps> = ({
  showHeader = true,
  showFooter = false,
  headerHeight = "h-6",
  contentLines = 3,
  className = ""
}) => {
  return (
    <Card className={`w-full ${className}`}>
      {showHeader && (
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <Skeleton className={`w-20 h-4 rounded-full`} />
            <Skeleton className="w-12 h-4 rounded-full" />
          </div>
          <Skeleton className={`w-3/4 ${headerHeight}`} />
        </CardHeader>
      )}
      
      <CardContent className="space-y-2">
        {Array.from({ length: contentLines }).map((_, i) => (
          <div key={i} className="flex items-center space-x-2">
            <Skeleton className="h-3 w-3 rounded-full" />
            <Skeleton className={`h-3 ${i === contentLines - 1 ? 'w-1/2' : 'w-full'}`} />
          </div>
        ))}
        
        {showFooter && (
          <div className="pt-2 space-y-2">
            <Skeleton className="h-6 w-full rounded-md" />
            <Skeleton className="h-6 w-20 rounded-md" />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export const SkeletonPollCard = () => (
  <SkeletonCard 
    showFooter={true}
    contentLines={2}
    className="h-fit bg-card shadow-sm border border-border"
  />
);

export const SkeletonMatchCard = () => (
  <SkeletonCard 
    showHeader={true}
    showFooter={true}
    contentLines={4}
    headerHeight="h-5"
  />
);

export const SkeletonUserCard = () => (
  <Card className="w-full">
    <CardContent className="p-4">
      <div className="flex items-center space-x-3">
        <Skeleton className="h-10 w-10 rounded-full" />
        <div className="space-y-2 flex-1">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-16" />
        </div>
        <Skeleton className="h-8 w-16 rounded-md" />
      </div>
    </CardContent>
  </Card>
);
